import { motion } from "framer-motion";
import { ASSETS } from "../lib/data";
import { useT } from "../lib/i18n";
import { MustacheMark } from "./MustacheMark";

export const Vibe = () => {
  const { t } = useT();
  const phrase = t("vibe.marquee");
  return (
    <section
      id="vibe"
      data-testid="vibe-section"
      className="relative bg-black text-white overflow-hidden"
    >
      <div
        data-testid="vibe-marquee"
        className="border-y border-gold/15 py-8 md:py-12 overflow-hidden"
      >
        <div className="flex w-max animate-marquee whitespace-nowrap">
          {Array.from({ length: 8 }).map((_, i) => (
            <span
              key={i}
              className="font-display italic text-5xl md:text-7xl lg:text-8xl px-8 text-white/85 flex items-center gap-8"
            >
              {phrase}
              <MustacheMark className="h-8 md:h-12 w-auto inline-block" color="#D4A857" />
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-4 md:gap-6">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 md:col-span-8 flex flex-col"
          >
            <div className="relative aspect-[16/10] overflow-hidden group">
              <img
                src={ASSETS.kioskFront}
                alt="Monsieur Toast kiosk front"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1500ms] ease-out"
              />
            </div>
            <div className="bg-[#0a0a0a] ring-1 ring-inset ring-gold/15 px-6 py-7 md:px-8 md:py-8 flex items-start justify-between gap-6">
              <div>
                <div className="text-[10px] tracking-[0.4em] uppercase text-gold/80">
                  {t("vibe.counter.kicker")}
                </div>
                <div className="mt-2 font-display italic text-2xl md:text-3xl text-white leading-snug">
                  {t("vibe.counter.title")}
                </div>
              </div>
              <MustacheMark className="h-5 w-auto shrink-0 mt-1" color="#D4A857" />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 md:col-span-4 relative aspect-[4/5] md:aspect-auto overflow-hidden bg-[#0a0a0a] flex flex-col justify-between p-8 md:p-10 ring-1 ring-inset ring-gold/15"
          >
            <MustacheMark className="h-6 w-auto" color="#D4A857" />
            <div>
              <div className="font-display italic text-3xl md:text-4xl leading-tight">
                {t("vibe.first.title.1")}{" "}
                <span className="text-gold">{t("vibe.first.title.2")}</span>
              </div>
              <div className="mt-4 text-white/55 font-light text-sm md:text-base leading-relaxed">
                {t("vibe.first.body")}
              </div>
            </div>
            <div className="text-[10px] tracking-[0.4em] uppercase text-gold/70">
              {t("vibe.first.foot")}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 md:col-span-6 relative aspect-[5/4] overflow-hidden group"
          >
            <img
              src={ASSETS.kioskSide}
              alt="Monsieur Toast counter detail"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1500ms] ease-out"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 md:col-span-6 relative aspect-[5/4] overflow-hidden bg-[#0a0a0a] flex flex-col justify-center items-center text-center p-10 ring-1 ring-inset ring-gold/15"
          >
            <div className="text-[10px] tracking-[0.4em] uppercase text-gold/80">
              {t("vibe.manifesto.kicker")}
            </div>
            <div className="mt-5 font-display text-3xl md:text-5xl leading-[1.05] tracking-tight">
              <span className="text-white">{t("vibe.manifesto.1")}</span>
              <br />
              <span className="text-white">{t("vibe.manifesto.2")}</span>
              <br />
              <span className="italic text-gold">{t("vibe.manifesto.3")}</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Vibe;
